import { Auth, Hub } from 'aws-amplify';

let cachedPromise: Promise<any> | null = null;
let cacheExpiry = 0;
const CACHE_TTL = 2000; // 2s — deduplicates closely-grouped bootstrap thunks

// Invalidate cache on sign-out, sign-in, or token refresh failure to prevent stale sessions
Hub.listen('auth', ({ payload }) => {
	if (payload.event === 'signOut' || payload.event === 'signIn' || payload.event === 'tokenRefresh_failure') {
		cachedPromise = null;
		cacheExpiry = 0;
	}
});

/**
 * Returns the current authenticated user, deduplicating concurrent calls.
 * Multiple thunks firing in the same tick share a single Auth resolution
 * instead of each making an independent Cognito lookup.
 * Resolved promise is kept for a short TTL (2s) so follow-up thunks in the
 * bootstrap sequence also reuse it. Cache is invalidated on auth state changes.
 */
export async function getCachedAuthUser() {
	// Reuse in-flight promise unconditionally; only check TTL after resolution
	if (!cachedPromise || (cacheExpiry > 0 && Date.now() > cacheExpiry)) {
		cacheExpiry = 0; // Mark as in-flight (not yet resolved)
		cachedPromise = Auth.currentAuthenticatedUser()
			.then((user) => {
				cacheExpiry = Date.now() + CACHE_TTL;
				return user;
			})
			.catch((err) => {
				cachedPromise = null;
				cacheExpiry = 0;
				throw err;
			});
	}
	return cachedPromise;
}
